import React, { useState } from "react";
import ContactPersonalInfo from "./ContactPersonalInfo";
import RelatedContactInfo from "./RelatedContactInfo";
import ContactAdditionalInfoTab from "./ContactAdditionalInfoTab";
import { getZipCodeByPlace } from "../addContact/contactApi";
import Utils from "../addContact/Utils";
import { addContactV2Style } from "./AddContactV2Style";

const PersonalContactInfoTabsItem = ({
  personalInfoRef,
  contactForm,
  setContactForm,
  relatedContactsRef,
  additionalInfoRef,
  customFields,
  customFieldsData,
  handleCustomFieldChange,
}) => {
  const [showAddress, setShowAddress] = useState(false);
  const GOOGLE_API_KEY = process.env.REACT_APP_MAP_KEY;
  const classes = addContactV2Style();

  const handleChangeDynamicInput = (field, key, value, index) => {
    if (field === "numbers" && key === "number") {
      if (!Utils.checkLetterExistInText(value) || value === "") {
        if (value.length > 0 && value[0] !== "1") {
          value = 1 + value;
        }
      } else {
        try {
          value = value.replace(/[^0-9]+/g, "");
          if (value.length > 0 && value[0] !== "1") {
            value = 1 + value;
          }
        } catch (e) {
          console.log(e);
        }
      }

      if (value.length > 11) {
        value = value.slice(0, 11);
      }
    }
    const tempContactForm = { ...contactForm };
    const tempFieldData = [...tempContactForm[field]];
    tempFieldData[index][key] = value;
    tempContactForm[field] = tempFieldData;
    setContactForm(tempContactForm);
  };

  const appendNumber = () => {
    const numberObj = {
      number: "",
      number_state: "mobile",
    };
    const tempContactForm = { ...contactForm };
    tempContactForm.numbers.push(numberObj);
    setContactForm(tempContactForm);
  };

  const appendEmail = () => {
    const emailObj = {
      email: "",
    };
    const tempContactForm = { ...contactForm };
    tempContactForm.emails.push(emailObj);
    setContactForm(tempContactForm);
  };

  const removeMultiField = (field, index) => {
    let tempContactForm = { ...contactForm };
    let tempFieldNumbers = [...tempContactForm[field]];
    tempFieldNumbers.splice(index, 1);
    tempContactForm[field] = tempFieldNumbers;
    setContactForm(tempContactForm);
  };

  const toggleAddress = () => {
    setShowAddress((prev) => !prev);
  };

  const updateContactInfo = (event, zip) => {
    let fullAddressArr = event.description.split(",");
    let address =
      fullAddressArr[0] !== undefined ? fullAddressArr[0].trim() : "";
    let city = fullAddressArr[1] !== undefined ? fullAddressArr[1].trim() : "";
    let fullState =
      fullAddressArr[2] !== undefined ? fullAddressArr[2].trim() : "";
    let country =
      fullAddressArr[3] !== undefined ? fullAddressArr[3].trim() : "";

    let stateArr = fullState.split(" ");
    let state = stateArr[0] !== undefined ? stateArr[0].trim() : "";

    setContactForm({
      ...contactForm,
      address: address,
      city: city,
      state: state,
      country: country,
      zip: zip,
    });
  };

  const handleAddress = async (event) => {
    let placeId =
      event.place_id !== undefined && event.place_id != null
        ? event.place_id
        : null;
    let zip = "";
    let road = "";
    let streetNumber = "";
    let state = "";
    let city = "";
    let country = "";
    let county = "";
    if (placeId != null) {
      try {
        await getZipCodeByPlace({
          placeId: placeId,
          googleAPIKey: GOOGLE_API_KEY,
        }).then((res) => {
          try {
            if (
              res.data.data.result.formatted_address !== undefined &&
              res.data.data.result.formatted_address != null
            ) {
              let data_array =
                res.data.data.result.formatted_address.split(",");
              if (data_array.length === 4) {
                let state_zip = data_array[2].trim().split(" ");
                setContactForm({
                  ...contactForm,
                  address: data_array[0].trim(),
                  city: data_array[1].trim(),
                  state: state_zip[0],
                  country: data_array[3],
                  zip: state_zip[1],
                });
              } else {
                zip = res?.data?.zip;
                if (
                  res.data.data.result.address_components &&
                  Array.isArray(res.data.data.result.address_components)
                ) {
                  res.data.data.result.address_components.map((item, index) => {
                    if (item.types[0] === "street_number") {
                      streetNumber = item.long_name;
                    } else if (item.types[0] === "route") {
                      road = item.long_name;
                    } else if (
                      item.types[0] === "administrative_area_level_1"
                    ) {
                      state = item.short_name;
                    } else if (
                      item.types[0] === "administrative_area_level_2"
                    ) {
                      city = item.long_name;
                    } else if (item.types[0] === "country") {
                      country = item.long_name;
                    } else if (item.types[0] === "postal_code") {
                      zip = item.long_name;
                    } else if (
                      item.types[0] === "administrative_area_level_3"
                    ) {
                      county = item.long_name;
                    }
                    setContactForm({
                      ...contactForm,
                      address: streetNumber + " " + road,
                      city: county !== "" ? county : city,
                      state: state,
                      country: country,
                      zip: zip,
                    });
                  });
                } else {
                  updateContactInfo(event, zip);
                }
              }
            } else {
              zip = res?.data?.zip;
              if (
                res.data.data.result.address_components &&
                Array.isArray(res.data.data.result.address_components)
              ) {
                res.data.data.result.address_components.map((item, index) => {
                  if (item.types[0] === "street_number") {
                    streetNumber = item.long_name;
                  } else if (item.types[0] === "route") {
                    road = item.long_name;
                  } else if (item.types[0] === "administrative_area_level_1") {
                    state = item.short_name;
                  } else if (item.types[0] === "administrative_area_level_2") {
                    city = item.long_name;
                  } else if (item.types[0] === "country") {
                    country = item.long_name;
                  } else if (item.types[0] === "postal_code") {
                    zip = item.long_name;
                  } else if (item.types[0] === "administrative_area_level_3") {
                    county = item.long_name;
                  }
                  setContactForm({
                    ...contactForm,
                    address: streetNumber + " " + road,
                    city: county !== "" ? county : city,
                    state: state,
                    country: country,
                    zip: zip,
                  });
                });
              } else {
                updateContactInfo(event, zip);
              }
            }
          } catch (error) {
            zip = res?.data?.zip;
            if (
              res.data.data.result.address_components &&
              Array.isArray(res.data.data.result.address_components)
            ) {
              res.data.data.result.address_components.map((item, index) => {
                if (item.types[0] === "street_number") {
                  streetNumber = item.long_name;
                } else if (item.types[0] === "route") {
                  road = item.long_name;
                } else if (item.types[0] === "administrative_area_level_1") {
                  state = item.short_name;
                } else if (item.types[0] === "administrative_area_level_2") {
                  city = item.long_name;
                } else if (item.types[0] === "country") {
                  country = item.long_name;
                } else if (item.types[0] === "postal_code") {
                  zip = item.long_name;
                } else if (item.types[0] === "administrative_area_level_3") {
                  county = item.long_name;
                }
                setContactForm({
                  ...contactForm,
                  address: streetNumber + " " + road,
                  city: county !== "" ? county : city,
                  state: state,
                  country: country,
                  zip: zip,
                });
              });
            } else {
              updateContactInfo(event, zip);
            }
          }
        });
      } catch (e) {
        updateContactInfo(event, "");
        console.log(e);
      }
    }
  };

  const handleInputField = (field, value) => {
    let tempContactForm = { ...contactForm };
    tempContactForm[field] = value;
    setContactForm(tempContactForm);
  };

  const makeAddress = () => {
    let address = "";

    address = contactForm.address;

    if (contactForm.city) {
      if (address) {
        address += " ";
      }
      address += contactForm.city;
    }

    if (contactForm.state) {
      if (address) {
        address += " ";
      }
      address += contactForm.state;
    }

    if (contactForm.country) {
      if (address) {
        address += " ";
      }
      address += contactForm.country;
    }

    if (contactForm.zip) {
      if (address) {
        address += " ";
      }
      address += contactForm.zip;
    }

    return address;
  };
  return (
    <div
      style={{
        width: "100%",
        border: "1px solid #e5e5e5",
        borderRadius: "4px",
        padding: 12,
        margin: "16px 0 16px 16px",
        maxHeight: "calc(100vh - 180px)",
        overflowY: "auto",
        paddingRight: "5px",
        backgroundColor: "white",
      }}
      className={classes.drawerBodyWrapper}
    >
      <ContactPersonalInfo
        personalInfoRef={personalInfoRef}
        contactForm={contactForm}
        handleChangeDynamicInput={handleChangeDynamicInput}
        appendNumber={appendNumber}
        removeMultiField={removeMultiField}
        appendEmail={appendEmail}
        handleInputField={handleInputField}
        handleAddress={handleAddress}
        showAddress={showAddress}
        toggleAddress={toggleAddress}
        makeAddress={makeAddress}
        setContactForm={setContactForm}
      />

      <RelatedContactInfo
        relatedContactsRef={relatedContactsRef}
        contactForm={contactForm}
        appendNumber={appendNumber}
        removeMultiField={removeMultiField}
        appendEmail={appendEmail}
        setContactForm={setContactForm}
      />

      <ContactAdditionalInfoTab
        additionalInfoRef={additionalInfoRef}
        customFields={customFields}
        customFieldsData={customFieldsData}
        handleCustomFieldChange={handleCustomFieldChange}
        contactForm={contactForm}
        setContactForm={setContactForm}
      />
    </div>
  );
};

export default PersonalContactInfoTabsItem;
